import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, MenuItem, Select, Stack, Typography } from "@mui/material";
import StyleIcon from "@mui/icons-material/Style";
import { DCSProvider } from "./Table/DCSContext";
import DocumentList from "./Table/Dashboard/DocumentList";
import PageHeader from "../../../../../components/PageHeader";
import { secondAxios } from "../../../../../api/axios";
import { Types } from "./DocReviewer";

/**
 * Standalone Document Register page — reached from the project hub's
 * "Document Register" tile. Previously nested inside DCS/EMS's Doc
 * Reviewer as a modal; self-provisions its own DCSContext so it doesn't
 * depend on being mounted under the /plant/:plantId/dcs route.
 */
export default function DocumentRegisterPage() {
  const { plantId } = useParams();
  const [type, setType] = useState("all");
  const [plantName, setPlantName] = useState("");

  useEffect(() => {
    if (!plantId) {
      setPlantName("");
      return;
    }
    let cancelled = false;
    secondAxios
      .get(`/plant/${plantId}`)
      .then((res) => {
        if (!cancelled) setPlantName(res.data?.name || "");
      })
      .catch(() => {
        if (!cancelled) setPlantName("");
      });
    return () => {
      cancelled = true;
    };
  }, [plantId]);

  return (
    <DCSProvider plant type={type}>
      <Box sx={{ p: { xs: 2, md: 3 } }}>
        <PageHeader
          plant={{ id: plantId, name: plantName }}
          pageTitle="Document Register"
        />

        <Stack
          direction="row"
          spacing={2}
          sx={{ alignItems: "center", flexWrap: "wrap", px: 2, pt: 2 }}
        >
          <StyleIcon color="secondary" sx={{ fontSize: 18 }} />
          <Typography variant="body2" color="primary" fontWeight={500}>
            Document Type:
          </Typography>
          <Select
            value={type}
            onChange={(e) => setType(e.target.value)}
            displayEmpty
            inputProps={{ "aria-label": "Select document type" }}
            sx={{
              width: 170,
              backgroundColor: "background.paper",
              height: 32,
              fontSize: "0.8125rem",
              "& .MuiSelect-select": { py: 0.75 },
            }}
          >
            <MenuItem value="all" sx={{ fontSize: "0.8125rem" }}>
              All Types
            </MenuItem>
            {Types.map((option) => (
              <MenuItem key={option} value={option} sx={{ fontSize: "0.8125rem" }}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </Stack>

        <Box sx={{ p: 2 }}>
          <DocumentList />
        </Box>
      </Box>
    </DCSProvider>
  );
}
